import React, { useEffect, useState } from "react";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { makeStyles, withStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import cl_flow from "assets/img/cl_flow.jpg";

const styles = {
    boxAlertPlano: {
        marginTop: 15,
        textAlign: 'center',
    },
    imgFlow50: {
        width: '50%',
    },
    imgFlow100: {
        width: '100%',
    }
};


const useStyles = makeStyles(styles);

export default function FlowMultas(props) {

    const classes = useStyles();
    const matches = useMediaQuery('(max-width:600px)');

    return (
        <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
                <div className={classes.boxAlertPlano}>
                    <img src={cl_flow} alt="Flow Multas" className={matches ? classes.imgFlow100 : classes.imgFlow50} />
                </div>
            </GridItem>
        </GridContainer>
    );
}